import { useState, useEffect } from "react";

const useEditableSectionLogic = (data, onSave) => {
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState(data || {});
  const [isSaving, setIsSaving] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData(data || {});
  }, [data]);

  const handleChange = (field, value) => {
    if (field === "pan_no") value = value.toUpperCase();
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateFields = () => {
    const newErrors = {};
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (formData.aadhar_no && !/^\d{12}$/.test(formData.aadhar_no)) {
      newErrors.aadhar_no = "Aadhaar must be 12 digits";
    }
    if (formData.pan_no && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.pan_no)) {
      newErrors.pan_no = "Invalid PAN format";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateFields()) return;

    const changedFields = {};
    for (const key in formData) {
      if (key !== "random_id" && formData[key] !== data[key]) {
        changedFields[key] = formData[key];
      }
    }

    if (Object.keys(changedFields).length === 0) {
      setEditMode(false);
      return;
    }

    if (changedFields.gender === "Male") changedFields.gender = "M";
    if (changedFields.gender === "Female") changedFields.gender = "F";

    setIsSaving(true);
    try {
      await fetch("https://be.corebankers.in/telecalling_pl_update", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          random_id: data?.random_id,
          updates: changedFields,
        }),
      });

      await onSave({ ...data, ...changedFields });
      setEditMode(false);
    } catch (err) {
      console.error("💥 Failed to save:", err);
      alert("Failed to save changes");
    } finally {
      setIsSaving(false);
    }
  };

  return {
    editMode,
    formData,
    isSaving,
    errors,
    handleChange,
    handleSave,
    setEditMode,
    setFormData,
    setErrors,
  };
};

export default useEditableSectionLogic;